module.exports = __webpack_public_path__ + "static/media/temp_w_domu_off_4.f946e651.svg";